import { render, staticRenderFns } from "./TheProjectSave.vue?vue&type=template&id=06efe628&"
import script from "./TheProjectSave.vue?vue&type=script&lang=js&"
export * from "./TheProjectSave.vue?vue&type=script&lang=js&"
import style0 from "./TheProjectSave.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports